export default {
    title: 'Members',
    search: 'Search members, rooms or tags',
    searchResults: {
        home: 'members, rooms and tags',
    },
    home: {
        rooms: 'Active Member Rooms',
        webcams: 'Member Webcams',
        friendsEmpty: 'None of your friends are on cam or hosting right now.',
    },
    tabs: {
        home: 'Home',
        friends: 'Friends',
        recents: 'Recents',
    },
    recent: {
        title: 'Recent',
        empty: 'Nothing yet. Member rooms you join and cams you watch show up here.',
        note: 'Member rooms you joined and cams you watched',
        room: 'Room',
        cam: 'Cam',
        open: 'Open now',
        closed: 'Closed',
        onCam: 'On cam',
        offline: 'Offline',
        byOwner: 'by {owner}',
        roomClosed: '"{room}" by {owner} has closed.',
        roomClosedUnknown: 'That room has closed.',
        camOffline: '{name} is not on cam right now.',
        camOfflineUnknown: 'This member is not on cam right now.',
    },
    sidebar: {
        onCam: 'On cam',
        leaveRoom: 'Leave {room}',
    },
    filters: {
        public: 'Public',
        friendsOnly: 'Friends only',
    },
    webcams: {
        description:
            'Live webcams from members whose privacy settings allow anyone to view their webcam. Members can change who may view their webcam in Personal Options > My Webcam > Security Levels.',
        note: 'Male members who intentionally pose as females may have their webcam privileges revoked or their accounts closed.',
        about: 'About member webcams',
        male: 'Males',
        female: 'Females',
        tstvtg: 'TS/TV/TG',
        notSpecified: 'Not Specified',
        gender: {
            male: 'M',
            female: 'F',
            tstvtg: 'TS/TV/TG',
            notSpecified: 'Not specified',
        },
        watch: 'Watch',
        yourCam: 'Your cam',
        yourCamNote: 'Listed because Show my webcam is on',
        liveBadge: 'Broadcasting',
        liveNote: 'Your webcam is on. Stop it here or from your room.',
        stop: 'Stop',
        settings: 'Settings',
    },
    rooms: {
        join: 'Join',
    },
    controls: {
        createRoom: 'Create a room',
        createRoomShort: 'New room',
        createRoomPremiumOnly:
            'Member rooms can only be created by premium members.',
        closeRoom: 'Close your room',
        closeRoomShort: 'Close room',
        goToRoom: 'Go to room',
        editTags: 'Edit your tags',
        addTags: 'Add tags',
        refresh: 'Refresh',
        sort: 'Sort',
        back: 'Back',
    },
    sort: {
        webcams: {
            friends: 'Friends first',
            name: 'Name A–Z',
            age: 'Age',
        },
        rooms: {
            busiest: 'Busiest',
            newest: 'Newest',
            name: 'Name A–Z',
        },
    },
    you: {
        title: 'You',
        listedBadge: 'Listed',
        open: 'Open',
        inRoom: '{count} in room',
        yourTags: 'Your tags',
        tagsUsed: '{count} of {max}',
        tagsNote: 'Members find you under these',
        editTags: 'Edit tags',
    },
    watchConfirm: {
        title: 'Watch a member webcam',
        message:
            "You're about to view {name}'s webcam. Member webcams are shared by members whose privacy settings allow it and are not model rooms. It opens in a private message, and the video starts when you press Show video.",
        ok: 'Watch',
        cancel: 'Cancel',
    },
    rails: {
        friendsOnCam: 'Friends on cam',
    },
    list: {
        byYou: 'by you',
        hosting: 'Hosting {room}',
        friend: 'Friend',
        owner: 'Owner',
        basicsAllowed: 'Basics allowed',
        modelsAllowed: 'Models allowed',
        since: 'since {time}',
        premiumOnly: 'Premium only',
        membersOnly: 'Members only',
        friendsOnly: 'Friends only',
        lounge: 'Lounge style',
        ownerWebcam: "{owner}'s Webcam",
    },
    tags: {
        tagged: '{tag}',
        taggedNote: '{count} members · online first',
    },
    empty: {
        webcams: 'No member webcams are on right now.',
        rooms: 'No member rooms are open right now.',
        roomsFiltered: 'No member rooms match your search or filters.',
        webcamsFiltered: 'No member webcams match your search or filters.',
        friendsFiltered: 'No friends match your search or filters.',
        recentFiltered: 'Nothing recent matches your search or filters.',
        roomsHint: 'Premium members can open one with New room above.',
        tagged: 'Nobody tagged {tag} is online right now.',
        taggedFiltered: 'No members tagged {tag} match your filters.',
    },
    errors: {
        webcams: 'Member webcams could not be loaded.',
        rooms: 'Member rooms could not be loaded.',
        tags: 'Member tags could not be loaded.',
        tagged: 'Members tagged {tag} could not be loaded.',
        yourTags: 'Your tags could not be loaded.',
        tryAgain: 'Try again',
    },
    promo: {
        guest: 'to watch member webcams and join member rooms',
        basicRooms: 'to open your own room and join every member room',
        webcamsPremium: 'Member webcams are for premium members.',
    },
    detail: {
        watch: 'Watch webcam',
        watchNote:
            'Webcams open in a private message. The video starts when you tap Show video.',
        sendPM: 'Send PM',
        profile: 'Profile',
        others: 'More member webcams',
    },
    create: {
        title: 'Create a room',
        preview: 'Preview',
        previewWebcam: 'Your webcam starts when you create the room',
        previewLounge: 'The lounge video plays here when the room opens',
        submitWebcam: 'Start cam and create',
        previewLoungeLive:
            'Your webcam stays on; a lounge-style room does not show it',
        name: 'Name',
        namePlaceholder: 'Name of your room',
        about: 'About',
        aboutPlaceholder: 'What happens in your room',
        color: 'Colour',
        join: 'Join',
        public: 'Public',
        friendsOnly: 'Friends only',
        video: 'Video',
        myWebcam: 'My webcam',
        lounge: 'Lounge style',
        allow: 'Allow',
        allowBasics: 'Basic members',
        allowModels: 'Models',
        notice: 'Your room can stay open for a while after you leave or log out, and others may still see it until it closes.',
        joinAfter: 'Join this room',
        submit: 'Create room',
        nameRequired: 'Choose a room name.',
        nameTooLong: 'Room names must be fewer than 64 characters.',
        failed: 'Your room could not be created. Try again.',
    },
    yourTags: {
        title: 'Your tags',
        preview: 'Preview',
        add: 'Add',
        addPlaceholder: 'A word or two',
        used: '{count} of {max} used',
        notice: 'Tags are public and help other members find you. Up to 32 tags of 32 characters; letters, numbers and spaces only.',
        save: 'Save tags',
        unsaved: 'Unsaved changes',
        loading: 'Loading your tags...',
        remove: 'Remove {tag}',
        full: 'You have used all {max} tags.',
        failed: 'Your tags could not be saved. Try again.',
    },
    room: {
        welcome: 'Welcome to "{room}", hosted by {owner}.',
        welcomeLounge: 'Welcome to "{room}".',
        loungeNote:
            'Note: the models on camera do not see the messages you type in this room.',
        friendsOnly: "This room is open to {owner}'s friends only...",
        premiumOnly: 'This room is open to premium members only...',
        closed: 'This room has closed. Member rooms close some time after their owner leaves...',
    },
}
